import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import {
  Container,
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
  FormErrorMessage,
  FormLabel,
  FormControl,
  Input,
  Button,
  useToast,
  HStack,
  Center,
  Textarea,
  Flex,
  Spacer,
  Select,
} from '@chakra-ui/react'
import { DatePicker } from 'antd'

import { ChevronRightIcon } from '@chakra-ui/icons'
import { FaCloudDownloadAlt } from 'react-icons/fa'
import { addDoc, collection } from 'firebase/firestore'
import { db } from '../../config/firebase'

function TimeAwayRequestForm({ user }) {
  const { handleSubmit, reset, register, errors, control } = useForm()
  const [isDisabled, setIsDisabled] = useState(false)
  const toast = useToast()

  function submitData(value) {
    setIsDisabled(true)
    value.date = value.date.format('YYYY-MM-DD')
    addDoc(collection(db, 'EmployeeForm'), {
      ...value,
      name: user.fullName,
      jobTitle: user.jobTitle,
      type: 'Time Away Request',
      createdAt: new Date(),
      notification: true,
      status: 'Pending',
    }).then(() => {
      toast({
        title: 'Submit Successfully',
        description: 'Form has been submmited.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      setIsDisabled(false)
      reset()
    })
  }

  return (
    <Container maxW="100%" mt="5">
      <Breadcrumb
        spacing="8px"
        separator={<ChevronRightIcon color="gray.500" />}
        bg="gray.100"
        p="1.5"
        borderRadius="0.3em"
      >
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/dashboard">
            Dashbaord
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/time-away-request-form">
            Time Away Request Form
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Box mt="30" mb="100" width={['100']}>
        <Flex mt="10" mb="10">
          <Box pt="2" fontSize="18" fontWeight="bold">
            Time Away Request Form
          </Box>
          <Spacer />
          <Button
            onClick={() => {
              window.open(
                'https://firebasestorage.googleapis.com/v0/b/paincare-a9e20.appspot.com/o/Downloads%2FForms%2FTime-Away-Request_form-2.pdf?alt=media&token=78c0933a-67a3-45f5-97c6-da9d8b35e43f',
                '_blank'
              )
            }}
            leftIcon={<FaCloudDownloadAlt />}
            size="sm"
          >
            PDF
          </Button>
        </Flex>
        <form onSubmit={handleSubmit(submitData)} id="time-away-request-form">
          <HStack mb="5">
            <FormControl id="name" isReadOnly>
              <FormLabel>NAME</FormLabel>
              <Input name="name" defaultValue={user.fullName} />
            </FormControl>
            <FormControl id="jobTitle" isReadOnly>
              <FormLabel>JOB TITLE</FormLabel>
              <Input name="jobTitle" defaultValue={user.jobTitle} />
            </FormControl>
          </HStack>
          <FormControl
            mb="5"
            id="facility"
            isInvalid={errors.facility}
            width={['100%', '100%', '100%', '50%']}
          >
            <FormLabel>FACILITY</FormLabel>
            <Controller
              render={props => (
                <Select onChange={props.onChange} placeholder="Select Facility">
                  <option value="PCSO">PCSO</option>
                  <option value="OSSC">OSSC</option>
                  <option value="OPM">OPM</option>
                </Select>
              )}
              name="facility"
              control={control}
              defaultValue={null}
              rules={{ required: 'Facility required.' }}
            />
            <FormErrorMessage>
              {errors.facility && errors.facility.message}
            </FormErrorMessage>
          </FormControl>
          <Center bg="black" mt="30" mb="30" h="35">
            <Text fontWeight="bold" color="white">
              DATE AND TIME AWAY REQUESTED
            </Text>
          </Center>
          <FormControl
            id="date"
            mb="5"
            width={['100%', '100%', '100%', '30%']}
            isInvalid={errors.date}
          >
            <FormLabel>DATE</FormLabel>
            <Controller
              render={props => (
                <DatePicker
                  onChange={props.onChange}
                  size="large"
                  format="YYYY-MM-DD"
                />
              )}
              name="date"
              control={control}
              defaultValue={null}
              rules={{ required: 'Date required.' }}
            />
            <FormErrorMessage>
              {errors.date && errors.date.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl
            id="reason"
            mb="5"
            width={['100%', '100%', '100%', '50%']}
            isInvalid={errors.reason}
          >
            <FormLabel>REASON</FormLabel>
            <Textarea
              name="reason"
              rows="6"
              ref={register({ required: 'Reson required.' })}
            />
            <FormErrorMessage>
              {errors.reason && errors.reason.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl
            id="hoursOfPtoRequested"
            mb="5"
            width={['100%', '100%', '100%', '50%']}
            isInvalid={errors.hoursOfPtoRequested}
          >
            <FormLabel>HOURS OF PTO REQUESTED</FormLabel>
            <Input
              name="hoursOfPtoRequested"
              ref={register({ required: 'Require Hours of PTO Request' })}
            />
            <FormErrorMessage>
              {errors.hoursOfPtoRequested && errors.hoursOfPtoRequested.message}
            </FormErrorMessage>
          </FormControl>
          <Text mb="5" color="red.500">
            ** Employee certifies that all information provided is true and
            complete to the best of his/her knowledge. Falsification of this
            form is grounds for disciplinary action, up to and including
            dismissal.
          </Text>
          <Center mt="10">
            <Button
              isLoading={isDisabled}
              disabled={isDisabled}
              type="submit"
              colorScheme="blue"
              width={['100%', '100%', '100%', '10%']}
            >
              Submit
            </Button>
          </Center>
        </form>
      </Box>
    </Container>
  )
}

export default TimeAwayRequestForm
